import React, {Component} from "react";
import {createHash} from "crypto";

/**
 * Original Ascii art by Art by Joan G. Stark: https://www.asciiart.eu/buildings-and-places/houses
 */
export class IntroBackgroundRestaurant extends Component{
    private readonly asciiBackgroundRestaurant: string[] = [
        "                               !!!!!!!\n" +
        "                       .       [[[|]]]    .\n" +
        "                       !!!!!!!!|--_--|!!!!!\n" +
        "                       [[[[[[[[\\_(X)_/]]]]]\n" +
        "               .-.     /-_--__-/_--_-\\-_--\\\n" +
        "               |=|    /-_---__/__-__-_\\__-_\\\n" +
        "           . . |=| ._/-__-__\\===========/-__\\_\n" +
        "           !!!!!!!!!\\========[ /]]|[[\\ ]=====/\n" +
        "          /-_--_-_-_[[[[[[[[[||==  == ||]]]]]]\n" +
        "         /-_--_--_--_|=  === ||=/^|^\\ ||== =|\n" +
        "        /-_-/^|^\\-_--| /^|^\\=|| | | | ||^\\= |\n" +
        "       /_-_-| | |-_--|=| | | ||=|_|_|=||\"|==|\n" +
        "      /-__--|_|_|_-_-| |_|_|=||______=||_| =|\n" +
        "     /_-__--_-__-___-|_=__=_.`---------'._=_|__\n" +
        "    /-----------------------\\===========/-----/\n" +
        "   ^^^\\^^^^^^^^^^^^^^^^^^^^^^[[|]]|[[|]]=====/\n" +
        "       |.' ..==::'\"'::==.. '.[ /~~~~~\\ ]]]]]]]\n" +
        "       | .'=[[[|]]|[[|]]]=`._||==  =  || =\\ ]\n" +
        "       ||== =|/ _____ \\|== = ||=/^|^\\=||^\\ ||\n" +
        "       || == `||-----||' = ==|| | | |=|| |=||\n" +
        "       ||= == ||:^s^:|| = == ||=| | | || |=||\n" +
        "       || = = ||:___:||= == =|| |_|_| ||_|=||\n" +
        "      _||_ = =||o---.|| = ==_||_= == =||==_||_\n" +
        "      \\__/= = ||:   :||= == \\__/[][][][][]\\__/\n" +
        "      [||]= ==||:___:|| = = [||]\\\\//\\\\//\\\\[||]\n" +
        "      }  {---'\"'-----'\"'- --}  {//\\\\//\\\\//}  {\n" +
        "    __[==]__________________[==]\\\\//\\\\//\\\\[==]_\n" +
        "   |`|~~~~|================|~~~~|~~~~~~~~|~~~~||\n" +
        "jgs|^| ^  |================|^   | ^ ^^ ^ |  ^ ||\n" +
        "  \\|//\\\\/^|/==============\\|/^\\\\\\^/^.\\^///\\\\//|///\n" +
        " \\\\///\\\\\\//===============\\\\//\\\\///\\\\\\\\////\\\\\\/////\n" +
        " \"\"'\"\"'\"\"\".'..'. ' '. ''..'.\"\"'\"\"'\"\"'\"\"''\"''\"''\"\""
    ];

    render() {
        let itemsList = this.asciiBackgroundRestaurant.map(function(item){
            const data = createHash('md5').update(item, 'ascii');
            return <span key={data.digest('hex')}>{item}<br/></span>;
        });
        return <pre>{ itemsList }</pre>
    }
}
